import {makeStyles} from "@material-ui/core";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";
import Config from '../../../../../config/config';
import ReactPlayer from "react-player";

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      lineHeight: 1,
      marginTop: 22,
      marginBottom: 16,
      fontSize: '25px!important',
    },
  },
  mainDescription: {
    fontFamily: 'roboto-light',
    fontSize: 20,
    color: '#212D40',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  },
  anchor: {
    color: '#017AEF',
    textDecoration: 'underline'
  },
  introTitle: {
    fontFamily: 'Spartan-bold',
    fontSize: (props: any) => props.height < 770 ? 60 : 80,
    color: '#E3645C',
    '@media (max-width: 600px)': {
      fontSize: '45px!important',
    },
  },
  introSubTitle: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    color: '#212D40',
    '@media (max-width: 600px)': {
      textAlign: 'center'
    },
  },
  introDescription: {
    fontFamily: 'roboto-light',
    fontSize: 14,
    color: '#212D40',
    textAlign: 'center'
  },
  introDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1
  },
  dataDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: (props: any) => props.height < 770 ? 20 : 50
  },
  videoDiv: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    paddingTop: (props: any) => props.height < 770 ? 10 : 30
  },
  mainDiv: {
    display: 'flex',
    marginBottom: (props: any) => props.height < 770 ? -30 : 0,
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  img: {
    zIndex: 10000,
    bottom: (props: any) => props.width < 1140 ? 50 : ((props.width >= 1140 && props.width < 1390) ? 10 : -30),
    left: 0,
    position: 'absolute',
    width: (props: any) => props.width < 960 ? '40%' : '40%',
    height: 'auto'
  }
}));

const Module1Slide2 = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const [playing, setPlaying] = useState(false);
  const [control, setControl] = useState(false);

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s2');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s2.id,
      preference_name: 'MODULE1S2',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 4) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '4',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(4))
  };

  const goBack = () => {
    dispatch(moveNextPage(2))
  };

  const onReady = () => {
    setPlaying(true);
    setControl(false);
  };

  const handlePause = () => {
    setPlaying(false);
  };

  const handlePlay = () => {
    setPlaying(true);
  };

  const videoEnded = () => {
    setPlaying(true);
    setControl(false);
  };

  return (
    <div>
      <div className={classes.title}>
        20 years of hardcore neuroscience at your fingertips.
      </div>

      <div className={classes.mainDescription}>
        You’re about to use 20 years of peer-reviewed neuroscience research on human decision-making. When people are emotionally engaged with something they’re experiencing, their brain releases the neurochemicals oxytocin and dopamine. These chemicals cause subtle changes in the way their heart beats. We convert these subtle signals into a second-by-second score. The higher the score, the more scientifically likely an audience is to remember and act on both the experience and the most immersive moments within it.
      </div>

      <div className={classes.mainDiv}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>

          <div className={classes.dataDiv}>
            <div className={classes.introDiv}>
              <div className={classes.introTitle}>17K</div>
              <div className={classes.introSubTitle}>Scientific Citations</div>
              <div className={classes.introDescription}>Puts our science in the top .03% of all discoveries.</div>
            </div>
            <div className={classes.introDiv}>
              <div className={classes.introTitle}>1.7B</div>
              <div className={classes.introSubTitle}>Data Points</div>
              <div className={classes.introDescription}>From our customers to predict outcomes in the past 3 years.</div>
            </div>
          </div>

          <div className={classes.dataDiv} style={{ paddingBottom: 50 }}>
            <div className={classes.introDiv}>
              <div className={classes.introTitle}>$4.1M</div>
              <div className={classes.introSubTitle}>Government Funding</div>
              <div className={classes.introDescription}>To identify and prove the science behind Immersion.</div>
            </div>
            <div className={classes.introDiv}>
              <div className={classes.introTitle}>#1</div>
              <div className={classes.introSubTitle}>Neuromarketing Expert</div>
              <div className={classes.introDescription}>Our team is the #1 leading scholar in neuromarketing & created neuroeconomics.</div>
            </div>
          </div>

          <span className={classes.mainDescription}>
            If you want to seriously nerd out,&nbsp;
            <a
              className={classes.anchor}
              rel="noreferrer"
              href={`${Config.INTERCOM_URL}/articles/5590684-the-science-of-immersion`}
              target={'_blank'}
            >
              learn more about the science here
            </a>.
          </span>
        </div>
        <div className={classes.videoDiv}>
          <img className={classes.img} src={'/assets/icons/onboarding/module1-slide2.svg'} alt={'Book Image'}/>
          <ReactPlayer
            width={'90%'}
            height={'auto'}
            url={'/assets/video/small_silent_doctor.mp4'}
            playing={playing}
            onReady={onReady}
            onPause={handlePause}
            onPlay={handlePlay}
            onEnded={videoEnded}
            controls={control}
            muted={true}
          />
        </div>
      </div>

      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight/>
    </div>
  )
};

export default Module1Slide2;